import { Component, Host, h, JSX, Event, EventEmitter, Prop } from '@stencil/core'

@Component({
    tag: 'zr-wishlist',
    styleUrl: 'zr-wishlist.scss',
    shadow: true,
})
/**
 VxWishlist component.
 */
export class ZrWishlist {

    /**
     * Describes whether product is on wishlist or not.
     */
    @Prop({ mutable: true }) productOnWishlist = true

    /**
     * Describes whether user is logged in or not.
     */
    @Prop() isLoggedIn = false

    /**
     * Event 'addToWishlistClicked' to emit to parent.
     */
    @Event() addToWishlistClicked: EventEmitter<object>

    /**
     * Click event handle function.
     */
    private addToWishlist = () => {
        this.productOnWishlist = !this.productOnWishlist
        this.addToWishlistClicked.emit({ active: this.productOnWishlist })
    }

    /**
     * Renders the component.
     *
     * @returns {JSX.Element} The rendered component.
     */
    render(): JSX.Element {
        return (
            <Host>
                <button
                    role="button"
                    class="wishlist-button"
                    aria-label={this.isLoggedIn ? 'Produkt der Wunschlist hinzufügen'
                        : 'Bitte anmelden um das Produkt der Wunschliste hinzuzufügen'}
                    onClick={this.addToWishlist}>
                    {this.isLoggedIn && this.productOnWishlist? (
                        <svg class="wishlist-icon"
                            xmlns="http://www.w3.org/2000/svg"
                            height="24"
                            viewBox="0 0 24 24"
                            width="24">
                            <path d="M0 0h24v24H0z" fill="none"/>
                            <path
                                d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28
                                2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81
                                4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58
                                3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55
                                11.54L12 21.35z"/>
                        </svg>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg"
                            height="24"
                            viewBox="0 0 24 24"
                            width="24">
                            <path d="M0 0h24v24H0z" fill="none"/>
                            <path
                                d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91
                                3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0
                                3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6
                                15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4
                                15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5
                                5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99
                                14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14
                                5.74-7.9 10.05z"/>
                        </svg>
                    )}
                </button>
            </Host>
        )
    }
}
